/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { GizmoKit } from './GizmoKit/GizmoKit';
import { Editor } from './GizmoKit/Editor';
/**
 * interface for generic editors
 */
export class AbstractEditor extends Editor {
    constructor(stage, options) {
        super();
        this._stage = stage;
        this._cameraName = options && options.cameraName || 'default';
        this._gizmoKit = new GizmoKit(this._stage.getCamera(this._cameraName), this);
    }
    getObject() {
        return this._object;
    }
    setObject(object) {
        if (!object && this._object) {
            this.clearObject();
            // tslint:disable-next-line:triple-equals
        }
        else if (this._object != object) {
            this.switchToObject(object);
        }
    }
    undo() {
        this._gizmoKit.undo();
    }
    redo() {
        this._gizmoKit.redo();
    }
    canUndo() {
        this._gizmoKit.canUndo();
    }
    canRedo() {
        this._gizmoKit.canRedo();
    }
    get _camera() {
        return this._stage.getCamera(this._cameraName);
    }
    get _stageDomElement() {
        return this._stage.getRenderer().domElement;
    }
    addEventListener(type, listener, options) {
        this._stage.addEventListener(type, listener);
    }
    dispatchEvent(event) {
        this._stage.dispatchEvent(event.type, { detail: event.detail });
    }
}
//# sourceMappingURL=AbstractEditor.js.map